import { colors } from '../../Colors/colors'

export const sidePaneTheme = {
   light: {
      sidePaneContainer: {
         borderColor: 'border-gray-300',
         backgroundColor: 'bg-base-white'
      },
      sidePaneHeader: {
         closeIconColor: colors['gray-500'],
         headerTextColor: 'text-gray-900',
         savedTextColor: 'text-gray-600',
         savedIconColor: colors['gray-500'],
         borderColor: 'border-gray-300',
         backLeftIconColor: colors['primary-600']
      },
      gofNavigationButton: {
         textColor: 'text-gray-700',
         dividerColor: 'bg-gray-200'
      },
      activityField: {
         labelColor: 'text-gray-600',
         borderColor: 'border-gray-200'
      },
      contactDetails: {
         basicDetails: 'text-gray-800',
         rightLineColor: 'bg-gray-400',
         skeletonBgColor: '#EAECF0', //FIXME: update hex codes
         skeletonColor: '#F6F7F9'
      }
   },
   dark: {}
}
